// PartsVu tenant theme defaults.
//
// These are the fallback values applied to the `:root` element at boot (see
// index.js) before — and if — the public tenant-config endpoint responds. Each
// `colors` key maps to a `--color-<key>` CSS custom property consumed by the
// SCSS. The values intentionally mirror the inline `var(--color-x, #hex)`
// fallbacks baked into the stylesheets, so PartsVu renders pixel-identically
// whether this JS runs, the config fetch succeeds, or everything fails.
//
// New tenants override any subset of these via a `colors` object in their
// TENANTS_JSON registry entry; unspecified keys fall back to these PartsVu
// values.
const partsvu = {
  displayName: 'PartsVu',
  colors: {
    'primary': '#E9B422',        // brand accent / primary button background
    'primary-hover': '#FBCD4F',  // primary button hover
    'on-primary': '#000000',     // text on the primary button
    'link': '#005B75',           // anchor links
    'heading': '#062743',        // headings, order number, section titles
    'text': '#000000',           // primary body text
    'text-muted': '#686868',     // descriptions, category names, image border
    'text-subtle': '#646464',    // status timestamps
    'border': '#D9D9D9',         // dividers, input borders, boxes, qty circle
    'border-alt': '#DEDEDE',     // search column divider
    'surface': '#FFFFFF',        // input / box backgrounds
    'surface-alt': '#FAFAFA',    // order detail right-hand panel background
    'spinner': '#112641',        // global loader spinner
  },
};

export default partsvu;
